import {
    FETCH_TOUR_GUIDES,
    FETCH_TOUR_GUIDES_SUCCESS,
    FETCH_TOUR_GUIDES_FAIL,

} from '../../types';

const initialState = {
    loading: false,
    guides: [],
    error: null
};

export const guidesReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_TOUR_GUIDES:
            return {
                ...state,
                loading: true
            };
        case FETCH_TOUR_GUIDES_SUCCESS:
            return {
                ...state,
                loading: false,
                guides: action.payload,
                error: null
            };
        case FETCH_TOUR_GUIDES_FAIL:
            return {
                ...state,
                loading: false,
                guides: [],
                error: action.payload
            };
        default:
            return state;
    }
}